
export const profile = {
  title: 'Tu Perfil de Personalidad',
  type: 'Tipo de Personalidad',
  traits: 'Rasgos Clave',
  workStyle: 'Estilo de Trabajo',
  communication: 'Estilo de Comunicación',
  basedOnWords: 'Basado en {{count}} palabras seleccionadas',
  behavioralFactors: 'Factores Conductuales (D-C-T-O)',
  objectivityFactor: 'Factor de Estilo (S)',
  subjective: 'Subjetivo',
  objective: 'Objetivo'
};

export const chart = {
  percentile: '° percentil',
  average: 'Promedio',
  scale: {
    low: 'Bajo',
    middle: 'Promedio',
    high: 'Alto'
  }
};

export const traits = {
  assertive: 'Asertivo',
  collaborative: 'Colaborativo',
  outgoing: 'Extrovertido',
  reserved: 'Reservado',
  steady: 'Estable',
  dynamic: 'Dinámico',
  structured: 'Estructurado',
  flexible: 'Flexible',
  analytical: 'Analítico',
  intuitive: 'Intuitivo',
  visionary: 'Visionario',
  teamOriented: 'Orientado al Equipo',
  systematic: 'Sistemático',
  relationshipBuilder: 'Constructor de Relaciones',
  teamBuilder: 'Constructor de Equipo',
  consistentPerformer: 'Desempeño Consistente',
  diplomaticLeader: 'Líder Diplomático',
  changeResistant: 'Resistente al Cambio',
  naturalLeader: 'Líder Natural',
  persuasiveCommunicator: 'Comunicador Persuasivo',
  resultsFocused: 'Enfocado en Resultados',
  adaptableToChange: 'Adaptable al Cambio',
  relationshipFocused: 'Enfocado en Relaciones',
  structuredApproach: 'Enfoque Estructurado',
  influential: 'Influyente',
  networkBuilder: 'Constructor de Redes',
  resultsDriven: 'Orientado a Resultados',
  systematicLeader: 'Líder Sistemático',
  strategicThinker: 'Pensador Estratégico',
  patientInnovator: 'Innovador Paciente',
  peopleFocused: 'Enfocado en Personas',
  patientLeader: 'Líder Paciente',
  measuredRiskTaker: 'Tomador de Riesgos Medidos',
  sustainableInnovator: 'Innovador Sostenible',
  technicalExpert: 'Experto Técnico',
  detailOriented: 'Orientado a Detalles',
  qualityFocused: 'Enfocado en Calidad',
  selfSufficient: 'Autosuficiente',
  goalOriented: 'Orientado a Objetivos',
  persistent: 'Persistente',
  selfMotivated: 'Auto-motivado',
  processMinded: 'Orientado a Procesos',
  selfReliant: 'Autoconfiable',
  quickDecisionMaker: 'Tomador de Decisiones Rápidas',
  taskFocused: 'Enfocado en Tareas',
  comfortableWithAmbiguity: 'Cómodo con Ambigüedad',
  decisive: 'Decisivo',
  efficient: 'Eficiente',
  direct: 'Directo',
  nurturing: 'Cuidador',
  organized: 'Organizado',
  inclusive: 'Inclusivo',
  processOriented: 'Orientado a Procesos',
  loyal: 'Leal',
  patient: 'Paciente',
  encouraging: 'Alentador',
  reliable: 'Confiable',
  enthusiastic: 'Entusiasmado',
  persuasive: 'Persuasivo',
  optimistic: 'Optimista',
  social: 'Social',
  spontaneous: 'Espontáneo',
  creative: 'Creativo',
  energetic: 'Energético',
  methodical: 'Metódico',
  thorough: 'Minucioso',
  diplomatic: 'Diplomático',
  consistent: 'Consistente',
  peaceful: 'Pacífico',
  versatile: 'Versátil',
  easyGoing: 'Tranquilo',
  supportive: 'Solidario',
  adaptable: 'Adaptable',
  wellRounded: 'Equilibrado',
  situational: 'Situacional'
};

export const personality = {
  inspirationalLeader: {
    type: 'Líder Inspiracional',
    description: 'Líder carismático que construye equipos estructurados y estables, impulsando la excelencia organizacional'
  },
  commander: {
    type: 'Comandante',
    description: 'Líder fuerte que valora las relaciones y la estabilidad, creando un impacto organizacional duradero'
  },
  executive: {
    type: 'Ejecutivo',
    description: 'Líder comandante e influyente que impulsa resultados a través de personas y pensamiento estratégico'
  },
  dynamicNetworker: {
    type: 'Networker Dinámico',
    description: 'Constructor de relaciones de alta energía que impulsa cambios a través de networking estructurado e influencia sistemática'
  },
  visionaryLeader: {
    type: 'Líder Visionario',
    description: 'Líder comandante que impulsa la innovación a través de visión estructurada y ejecución sistemática'
  },
  socialInnovator: {
    type: 'Innovador Social',
    description: 'Constructor de relaciones paciente que crea cambio a través de innovación colaborativa y soluciones enfocadas en personas'
  },
  strategicEntrepreneur: {
    type: 'Emprendedor Estratégico',
    description: 'Líder paciente pero decisivo que construye innovación sostenible a través de pensamiento estratégico y toma de riesgos medida'
  },
  specialist: {
    type: 'Especialista',
    description: 'Especialista que prefiere trabajo estructurado e independiente, manteniendo altos estándares de calidad y precisión'
  },
  achiever: {
    type: 'Realizador',
    description: 'Individuo orientado a resultados que valora la consistencia y enfoques sistemáticos para el logro de objetivos'
  },
  pioneer: {
    type: 'Pionero',
    description: 'Realizador independiente que prefiere acción directa y prospera en ambientes no estructurados y desafiantes'
  },
  independent: {
    type: 'Independiente',
    description: 'Individuo auto-motivado que prefiere autonomía y acción directa, manteniendo altos estándares personales'
  },
  teamBuilder: {
    type: 'Constructor de Equipo',
    description: 'Líder enfocado en relaciones que crea ambientes estructurados e inclusivos donde todos pueden prosperar'
  },
  supporter: {
    type: 'Partidario',
    description: 'Jugador de equipo enfocado en personas que valora la estabilidad y crea relaciones profesionales duraderas y significativas'
  },
  influencer: {
    type: 'Influyente',
    description: 'Motivador enfocado en personas que abraza el cambio e inspira a otros a través del entusiasmo y energía positiva'
  },
  networker: {
    type: 'El Conector',
    description: 'Colaborativo y extrovertido, sobresales construyendo relaciones y uniendo personas'
  },
  systematizer: {
    type: 'Sistematizador',
    description: 'Individuo orientado a procesos que valora la calidad, consistencia y enfoques sistemáticos para la excelencia en el trabajo'
  },
  facilitator: {
    type: 'Facilitador',
    description: 'Miembro estable del equipo que mantiene armonía, construye consenso y crea ambientes de trabajo colaborativos donde todos se sienten valorados'
  },
  collaborator: {
    type: 'Colaborador',
    description: 'Jugador de equipo flexible que se adapta perfectamente a cualquier situación, manteniendo dinámicas de equipo positivas'
  },
  harmonizer: {
    type: 'Armonizador',
    description: 'Individuo adaptable que mantiene equilibrio en todas las situaciones, promoviendo relaciones positivas y estabilidad organizacional'
  },
  professional: {
    type: 'Profesional',
    description: 'Demuestra características equilibradas en todas las dimensiones conductuales con enfoque profesional adaptable'
  }
};

export const professional = {
  style: {
    title: 'Estilo Profesional',
    subtitle: 'Tu enfoque natural al trabajo y colaboración'
  },
  workStyle: {
    title: 'Preferencias de Estilo de Trabajo'
  },
  communication: {
    title: 'Estilo de Comunicación'
  }
};

export const workStyle = {
  fastPaced: 'Enfoque dinámico y acelerado',
  collaborative: 'Orientado al equipo y colaborativo',
  structured: 'Organizado y sistemático',
  flexible: 'Adaptable y flexible',
  adaptable: 'Adaptable a varios ambientes de trabajo',
  balanced: 'Enfoque equilibrado a los desafíos laborales',
  teamGoals: 'Enfoque estructurado para objetivos de equipo',
  teamInteraction: 'Interacción regular del equipo y retroalimentación',
  adaptableProfessional: 'Enfoque profesional adaptable',
  leadsInspiration: 'Lidera a través de inspiración y procesos estructurados',
  buildsConsensus: 'Construye consenso mientras impulsa resultados',
  strategicLeadership: 'Liderazgo estratégico con enfoque en resultados',
  networksSystematic: 'Construye redes a través de gestión sistemática de relaciones',
  structuredVision: 'Lidera a través de visión estructurada y planificación sistemática',
  patientInnovation: 'Innovación paciente a través de relaciones colaborativas',
  strategicEntrepreneurship: 'Emprendimiento estratégico con ejecución paciente',
  independentExpertise: 'Experiencia independiente con enfoque sistemático',
  systematicGoal: 'Logro sistemático de objetivos y consistencia',
  independentAction: 'Acción independiente en ambientes dinámicos',
  autonomousTask: 'Ejecución autónoma y eficiente de tareas',
  collaborativeTeam: 'Construcción colaborativa de equipo con estructura',
  supportiveRelationship: 'Enfoque solidario y enfocado en relaciones',
  motivationalAdaptable: 'Enfoque motivacional y adaptable',
  dynamicNetworking: 'Networking dinámico y construcción de relaciones',
  systematicQuality: 'Ejecución sistemática y enfocada en calidad',
  harmoniousConsensus: 'Enfoque armonioso y construcción de consenso',
  flexibleCollaborative: 'Apoyo flexible y colaborativo al equipo',
  harmoniousAdaptable: 'Enfoque armonioso y adaptable',
  supportiveRole: 'Papel de apoyo estructurado y solidario',
  flexibleApproach: 'Enfoque flexible y adaptativo'
};

export const communication = {
  balanced: 'Comunicación equilibrada y reflexiva',
  adaptive: 'Adapta estilo a audiencia y situación',
  direct: 'Comunicación clara y directa',
  supportive: 'Alentador y solidario',
  informal: 'Enfoque informal y directo',
  diplomatic: 'Comunicación diplomática y estructurada',
  consensus: 'Construyendo consenso a través de discusión',
  enthusiastic: 'Estilo entusiasmado y atractivo',
  situational: 'Estilo de comunicación situacional',
  engagingOrganized: 'Estilo de comunicación atractivo y bien organizado',
  diplomaticDecisive: 'Enfoque de comunicación diplomático pero decisivo',
  persuasiveResults: 'Diálogo persuasivo y orientado a resultados',
  enthusiasticOrganized: 'Estilo de networking entusiasmado y organizado',
  commandingOrganized: 'Estilo de liderazgo comandante pero organizado',
  collaborativePatient: 'Enfoque colaborativo y paciente centrado en personas',
  strategicMeasured: 'Diálogo de liderazgo estratégico y medido',
  preciseTechnical: 'Estilo de comunicación preciso y técnico',
  clearGoal: 'Diálogo claro y enfocado en objetivos',
  directAction: 'Intercambios directos y orientados a la acción',
  directEfficient: 'Estilo de comunicación directo y eficiente',
  inclusiveSupportive: 'Diálogo inclusivo y solidario',
  encouragingPatient: 'Intercambios alentadores y pacientes',
  enthusiasticPersuasive: 'Estilo entusiasmado y persuasivo',
  socialSpontaneous: 'Intercambios sociales y espontáneos',
  methodicalThorough: 'Diálogo metódico y minucioso',
  diplomaticPeaceful: 'Intercambios diplomáticos y pacíficos',
  adaptableSupportive: 'Diálogo adaptable y solidario',
  peacefulFlexible: 'Intercambios pacíficos y flexibles',
  conciseAndFocused: 'Comunicación concisa y enfocada',
  quickResponse: 'Respuestas rápidas y directas',
  informalStyle: 'Estilo informal y accesible'
};
